<template>
  <div class="worker-manage">
    <div class="vx-row">
      <div class="vx-col w-full vx-card" style="min-height: 230px">
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <div class="flex items-center" style="height: 60%">
              <div class="vx-row md:text-lg text-white font-semibold w-full">
                <div class="vx-col w-1/3">
                  <vx-card class="flex justify-center" style="background: rgba(var(--vs-primary),.8)">
                    <span class="mr-2">Processed: </span>
                    <span>{{ totalProcessed }}</span>
                  </vx-card>
                </div>
                <div class="vx-col w-1/3">
                  <vx-card class="flex justify-center" style="background: rgba(var(--vs-danger),.8)">
                    <span class="mr-2">Failed:</span>
                    <span>{{ totalFailed }}</span>
                  </vx-card>
                </div>
                <div class="vx-col w-1/3">
                  <vx-card class="flex justify-center" style="background: rgba(var(--vs-success),.8)">
                    <span class="mr-2">Succeeded:</span>
                    <span>{{ totalSucceeded }}</span>
                  </vx-card>
                </div>
              </div>
            </div>
            <div class="text-sm" style="height: 40%">
              <p><span class="text-danger">*</span>Ghi chú:</p>
              <ul>
                <li>
                  <vs-radio color="primary">Tiến trình đã chạy.</vs-radio>
                </li>
                <li>
                  <vs-radio color="danger">Tiến trình đã chạy bị lỗi.</vs-radio>
                </li>
                <li>
                  <vs-radio color="success">Tiến trình đã chạy thành công.</vs-radio>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mt-0 mt-6">
            <vue-apex-charts ref="dataStatus" type="pie" :options="dataStatus.chartOptions"
                             :series="dataStatus.series"></vue-apex-charts>
          </div>
        </div>
      </div>
      <div class="vx-col w-full vx-card p-4 mt-6">
        <div class="vx-row mt-2">
          <div class="vx-col sm:w-2/3 w-full sm:mt-0 mt-4">
            <vs-input class="md:w-1/2 w-full"
                      label="Tìm kiếm: "
                      v-model="keySearch"
                      @input="updateSearchQuery" placeholder="Nhập từ khóa"/>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-button class="mt-6 float-right" icon-pack="feather" icon="icon-refresh-cw" @click="search">Refresh</vs-button>
          </div>
        </div>
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="dataWorker"
                     :animateRows="true"
                     :localeText=" {noRowsToShow: 'Không có dữ liệu'}"
                     :paginationPageSize="pageSize"
                     :pagination="true"
                     @pagination-changed="onPaginationChanged"
                     @grid-ready="onGridReady"
                     :autoSizeStrategy="autoSizeStrategy">
        </ag-grid-vue>

        <div class="w-full flex" v-if="dataWorker.length > 0">
          <div style="min-width:200px">
            <span class="content-page font-bold ml-4">Hiển thị: </span><span
            class="text-page">{{ countElementPage > totalElements ? totalElements : countElementPage }} /
                            {{ totalElements }} </span>
          </div>
          <vs-pagination
            :total="totalPages"
            v-model="currentPage"
            @change="loadPage"
            max="6"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererStatus from "@/views/admin-pages/worker-manage/cell-renderer/CellRendererStatus";
import VueApexCharts from 'vue-apexcharts';

export default {
  name: "WorkerManage",
  components: {
    AgGridVue,
    CellRendererStatus,
    VueApexCharts,
  },

  data() {
    return {
      columnDefs: [
        {
          headerName: 'Worker Name',
          field: 'hostname',
          width: 300,
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 200,
          cellRenderer: 'CellRendererStatus',
        },
        {
          headerName: 'Processed',
          field: 'processed',
          width: 200,
        },
        {
          headerName: 'Failed',
          field: 'task-failed',
          width: 200,
        },
        {
          headerName: 'Succeeded',
          field: 'task-succeeded',
          width: 200,
        },
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        flex: 1,
      },
      pageSize: 20,
      pageNumber: 1,
      currentPage: 1,
      keySearch: null,
      totalPages: 1,
      totalElements: 0,
      countElementPage: 0,
      dataWorker: [],
      autoSizeStrategy: {
        type: 'fitGridWidth',
      },
      dataStatus: {
        chartOptions: {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: ['Online', 'Offline'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
            }
          }],
          colors: ['rgba(var(--vs-success),1)', 'rgba(var(--vs-danger),1)'],
          legend: {
            position: 'bottom'
          }
        },
        series: [],
      },
      totalProcessed: 0,
      totalFailed: 0,
      totalSucceeded: 0,
      status: {
        online: 0,
        offline: 0,
      }
    }
  },

  created() {
    this.getWorkerData();
  },

  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
    },

    onPaginationChanged() {
      if (this.gridApi) {
        this.totalPages = this.gridApi.paginationGetTotalPages();
      }
    },
    loadPage: function (currentPage) {
      if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
    },

    search() {
      this.currentPage = 1;
      if (this.gridApi) this.gridApi.paginationGoToPage(this.currentPage - 1)
      this.getWorkerData();
    },

    getWorkerData() {
      this.$vs.loading();
      this.$task.get('/newspaper/workers').then(res => {
        this.totalProcessed = this.totalFailed = this.totalSucceeded = 0;
        this.status.online = this.status.offline = 0;
        if (res.data.data && res.data.data.length > 0) {
          this.dataWorker = res.data.data.map(el => {
            el['task-failed'] = el['task-failed'] ? el['task-failed'] : 0;
            el['task-succeeded'] = el['task-succeeded'] ? el['task-succeeded'] : 0;
            this.totalProcessed = this.totalProcessed + el.processed;
            this.totalFailed = this.totalFailed + el['task-failed'];
            this.totalSucceeded = this.totalSucceeded + el['task-succeeded'];
            if (el.status) {
              this.status.online ++
            } else {
              this.status.offline ++
            }
            return el;
          });
        } else {
          this.dataWorker = []
        }
        this.$refs.dataStatus.updateOptions({
          series: [this.status.online, this.status.offline]
        })
        this.countElementPage = this.currentPage * this.pageSize;
        this.totalElements = this.dataWorker.length;
        this.$vs.loading.close()
      }).catch((err) => {
        this.$vs.loading.close()
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    updateSearchQuery(val) {
      this.gridApi.setGridOption('quickFilterText', val);
    },
  },
}
</script>

<style lang="scss">
.ag-paging-panel {
  display: none !important;
}
</style>
